import { Guid } from '../guid';
import { MapperBase } from '../../utilities/mapper-base';
import { UserResource } from '../resource/user.resource';
import { User } from '../ui/user.model';
import { RoleToUserRoleResourceMapper } from './role-to-user-role-resource.mapper';

export class UserToUserResourceMapper extends MapperBase<User, UserResource> {
	map(source: User): UserResource {
		const dest = {} as UserResource;
		const mapper = new RoleToUserRoleResourceMapper();
		dest.id = source?.id ? source.id.toLowerCase() : Guid.Empty;
		dest.userName = source?.userName ?? '';
		dest.email = source?.email ?? '';
		dest.emailConfirmed = source?.emailConfirmed;
		dest.phoneNumber = source?.phoneNumber;
		dest.phoneNumberConfirmed = source?.phoneNumberConfirmed;
		dest.twoFactorEnabled = source?.twoFactorEnabled;
		dest.roles = mapper.mapCollection(source?.roles);
		dest.createDate = source?.createDate ?? '';
		dest.lastActivityDate = source?.lastActivityDate ?? '';
		dest.lastLoginDate = source?.lastLoginDate ?? '';
		dest.accounts = [];
		dest.cases = [];
		return dest;
	}

}
